import ApiEndpoint from 'network/ApiEndpoint'
interface Response {
  hasError: boolean
  errors?: any
}
export const deleteStartPageBanner = async (
  channelSlug: string
): Promise<Response> => {
  try {
    const response = await ApiEndpoint.call({
      path: 'banners/frontpage',
      method: ApiEndpoint.METHODS.DELETE,
      params: { company: channelSlug },
      authenticatable: true
    })
    await response
    return { hasError: false }
  } catch (error: any) {
    console.error('error!', error)
    return {
      hasError: true,
      errors: [error]
    }
  }
}
